import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import Reveal from '../ui/Reveal';
import { REASONS } from '../../data/site';

export default function WhyVoila() {
  return (
    <section className="section" id="why">
      <div className="container">
        <SectionHeader
          eyebrow="Why Voila / 02"
          title="The studio you'd hire if your CTO had a free afternoon."
          lede="A tight team of senior engineers, designers, and AI specialists. We work with founders who care about the difference between built and built-well."
        />
        <div className="why-grid">
          {REASONS.map((r, i) => (
            <Reveal key={r.num} delay={i * 0.06}>
              <div className="why-cell">
                <div className="num">{r.num}</div>
                <h3>{r.title}</h3>
                <p>{r.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
